import React from 'react';
import classnames from 'classnames';
import { List } from 'immutable';

import FeatureFlagStore from '../../stores/FeatureFlagStore';
import { translate as t } from '../../lib/I18n';
import { PointStages, SeasonStages, OtherTicketStages } from '../../constants/AppConstants';

import Link from '../general/Link';

function SearchTabs () {

    function _getTabs () {
        const classNames = 'pull-left text-center text-sm';

        let tabs = new List();
        tabs = tabs.push( <Link key="point"
                                to={ PointStages.SEARCH }
                                className={ classNames }
                                srOnly={ t('global.searchFor') }>
                                    { t('nav.pointTickets') }
                          </Link> );
        if (FeatureFlagStore.get('enableSeasonTickets')) {
            tabs = tabs.push( <Link key="season"
                                    to={ SeasonStages.SEARCH }
                                    className={ classNames }
                                    srOnly={ t('global.searchFor') }>
                                        { t('nav.seasonTickets') }
                              </Link> );
        }
        if (FeatureFlagStore.get('enableOtherTickets')) {
            tabs = tabs.push( <Link key="other"
                                    to={ OtherTicketStages.SEARCH }
                                    className={ classNames }
                                    srOnly={ t('global.searchFor') }>
                                        { t('nav.otherTickets') }
                              </Link> );
        }
        return tabs;
    }

    const tabs = _getTabs();

    const tabsClasses = classnames('search-tabs', {
        'search-tabs--thirds': tabs.size === 3
    });

    return (
        <div className={ tabsClasses }>
            { tabs.size > 1 ?
                <nav role="navigation" className="clearfix">
                    { tabs }
                </nav>
            :
                <h2 className="text-center border--bottom">
                    { t('nav.heading') }
                </h2>
            }
        </div>
    );
}

export default SearchTabs;



// WEBPACK FOOTER //
// ./src/components/search/SearchTabs.js